/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.busyModule')
.directive('bulbInlineBusy', ['$compile','$templateRequest','CONFIG', bulbInlineBusy]);

function bulbInlineBusy($compile, $templateRequest, CONFIG) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element, attrs) {
      scope.busy = true;

      attrs.$observe('bulbInlineBusy', function(newValue) {
        scope.busy = newValue === 'true' || newValue === '';
      });

      $templateRequest('ajs/components/busy/inlinebusy.html').then(function(result) {
        var template = angular.element(result);
        element.append(template);
        $compile(template)(scope);
      });
    }
  };
}
